import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUsersIconSolid = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "a",
	xmlns: "http://www.w3.org/2000/svg",
	width: 75,
	height: 60,
	viewBox: "0 0 75 60",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M25.44,35.62H2.06c-1.14,0-2.06-.98-2.06-2.19,0-6.04,4.62-10.93,10.32-10.93h7.24c1.49,0,2.89,.25,4.17,.95-.07,.62-.19,1.23-.19,1.86,0,3.95,1.5,7.52,3.89,10.31ZM5.62,9.38C5.62,4.2,9.82,0,15,0s9.38,4.2,9.38,9.38-4.2,9.38-9.38,9.38S5.62,14.55,5.62,9.38ZM60,56.87c0,1.73-1.49,3.13-3.33,3.13H18.33c-1.84,0-3.33-1.39-3.33-3.13,0-8.62,7.45-15.62,16.65-15.62h11.7c9.2,0,16.65,7,16.65,15.62ZM25.41,25.31c0-6.73,5.35-12.19,12.08-12.19s12.08,5.46,12.08,12.19-5.35,12.19-12.08,12.19-12.19-5.46-12.08-12.19Zm49.59,8.12c0,1.21-.93,2.19-2.07,2.19h-23.4c2.39-2.79,3.89-6.36,3.89-10.31,0-.63-.12-1.23-.19-1.85,1.29-.61,2.7-.97,4.2-.97h7.25c5.71,0,10.32,4.9,10.32,10.93ZM50.62,9.38c0-5.18,4.2-9.38,9.38-9.38s9.38,4.2,9.38,9.38-4.2,9.38-9.38,9.38-9.38-4.2-9.38-9.38Z" })]
});
const ForwardRef = forwardRef(SvgUsersIconSolid);
export default ForwardRef;
